import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';

registerBlockType(metadata.name, {
  edit: Edit,
  // Rendered by render.php — the value, the clamping and the accessible
  // attributes all belong on the server, where they are correct with JS off.
  save: () => null,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* Track */}
        <path d="M3 9h18a3 3 0 0 1 0 6H3a3 3 0 0 1 0-6zm0 2a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2H3z" />
        {/* Fill */}
        <rect x="3" y="10.5" width="11" height="3" rx="1.5" />
      </svg>
    ),
  },
});
